import CobrandCtrl from './cobrand-register/cobrand-register.ctrl';
import CobrandAdminCtrl from './cobrand-admin/cobrand-admin.ctrl';
import CobrandImportCtrl from './cobrand-admin/cobrand-admin-import/cobrand-admin-import.ctrl';
import { cdnTemplate } from 'cdnPreprocessor';

export default angular.module('cui.cobrand', ['ui.router'])
  .controller('CobrandCtrl', CobrandCtrl)
  .controller('CobrandAdminCtrl', CobrandAdminCtrl)
  .controller('CobrandImportCtrl', CobrandImportCtrl)
  .config([
    '$stateProvider', '$urlRouterProvider',
    function($stateProvider, $urlRouterProvider) {
      $urlRouterProvider.when('/cobrand-admin', '/cobrand-admin/import');

      $stateProvider
        .state('cobrand-register', {
          url: '/register/partner?pid',
          controller: 'CobrandCtrl as cobrand',
          templateUrl: cdnTemplate('/cobrand-register.html'),
          params: {
            'pid': null
          }
        })
        .state('cobrand-admin', {
          url: '/cobrand-admin',
          abstract: true,
          controller: 'CobrandAdminCtrl as cobrandAdmin',
          templateUrl: cdnTemplate('/cobrand-admin.html')
        })
        .state('cobrand-admin.import', {
          url: '/import',
          controller: 'CobrandImportCtrl as import',
          templateUrl: cdnTemplate('/cobrand-admin-import.html')
        });
    }
  ]);


// WEBPACK FOOTER //
// ./source/client/pages/cobrand/index.js